import { localStorageSetItemWithQuotaRecovery } from './localStorageQuota';

export type ClassPointGaugeViewMode = 'full' | 'next';

const KEY_PREFIX = 'cp-class-point-gauge-mode:';

export function classPointGaugeModeStorageKey(workspaceId: string, gradeId: string): string {
  return `${KEY_PREFIX}${workspaceId}:${gradeId}`;
}

export function readClassPointGaugeViewMode(
  workspaceId: string,
  gradeId: string
): ClassPointGaugeViewMode {
  if (typeof window === 'undefined') return 'full';
  if (!workspaceId.trim() || !gradeId.trim()) return 'full';
  try {
    const raw = window.localStorage.getItem(classPointGaugeModeStorageKey(workspaceId, gradeId));
    return raw === 'next' ? 'next' : 'full';
  } catch {
    return 'full';
  }
}

export function writeClassPointGaugeViewMode(
  workspaceId: string,
  gradeId: string,
  mode: ClassPointGaugeViewMode
): void {
  if (typeof window === 'undefined') return;
  if (!workspaceId.trim() || !gradeId.trim()) return;
  try {
    localStorageSetItemWithQuotaRecovery(
      classPointGaugeModeStorageKey(workspaceId, gradeId),
      mode
    );
  } catch {
    /* ignore */
  }
}
